<template>
    <transition>
        
        <div  :class="$style.button"
               v-show="active" 
               @click="toTop">
            <div :class="$style.arrow_top"></div>
        </div>

    </transition>
</template>

<script lang="ts">

import Vue from "vue";

export default Vue.extend({
    name: "HeaderReturn",

    data: function() {
                return {active: false}
    },

    mounted() {
     window.addEventListener('scroll', this.isScroll)
    },

    methods: {
    //トップに戻る
        toTop() {
          window.scrollTo(0, 0);
        },
        isScroll(){
            const top = 0
            this.scroll = window.scrollY
            if (top < this.scroll){
                this.active = true
            }else{
                this.active = false
            }
        }
  }
  
});
</script>

<style lang="scss" module>

//sp
@media only screen and (max-width: 1023px) {
    $font_size: 15px;
    $font_color: #fff;
    $background-color: #333333;    
    
    .button {
        @mixin circle($color){
        background-color: #333333;
        width: 80px;
        height: 80px;
        border-radius: 40px;
        margin-bottom: 40px;
        text-align: center;
        font-size: 130%;
        line-height: 50px;
        opacity:0.6;
        }


        background: rgba($background-color, 0.7);
        z-index: 980;
        position: fixed;
        display: inline-block;
        right: 20px;
        bottom: 10px;
        transition:0s;

        
        content: "";
        @include circle(#305097);
        width: 40px;
        height: 40px;
        border: 0px;
        transform: rotate(-45deg);
        position: fixed;
        bottom: 30px;
        right: 10px;
        &:hover{
            background: lighten(rgba($background-color, 0.7), 10%);
        }
        
        .arrow_top {
            position: relative;
            left: 15px;
            top:  16px;
            z-index: 0;
            border-top: solid 2px #ffffff;
            border-left: solid 2px #ffffff;
            width: 8px;
            height: 8px;
            transform: rotate(90deg);
            
        }
    }
}

//pc
@media only screen and (min-width: 1024px) {
    
    $font_size: 15px;
    $font_color: #fff;
    $background-color: #333333;    
    
    .button {
        @mixin circle($color){
        background-color: #333333;
        width: 100px;
        height: 100px;
        border-radius: 50px;
        margin-bottom: 50px;
        text-align: center;
        font-size: 130%;
        line-height: 50px;
        opacity:0.6;
        }


        background: rgba($background-color, 0.7);
        z-index: 980;
        position: fixed;
        display: inline-block;
        right: 20px;
        bottom: 10px;
        transition:0s;

        
        content: "";
        @include circle(#305097);
        width: 50px;
        height: 50px;
        border: 0px;
        transform: rotate(-45deg);
        position: fixed;
        bottom: 30px;
        right: 100px;
        &:hover{
            background: lighten(rgba($background-color, 0.7), 10%);
        }
        
        .arrow_top {
            position: relative;
            left: 14px;
            top:  20px;
            z-index: 0;
            border-top: solid 3px #ffffff;
            border-left: solid 3px #ffffff;
            width: 15px;
            height: 15px;
            transform: rotate(90deg);
            
        }
    }
    

    
}

</style>
